<div class="assistance-service-container">
  <div class="title-container">
    <h2><span nz-icon nzType="bulb" nzTheme="outline"></span>{{ 'assistanceService.title' | translate }}</h2>
    <p>{{ 'assistanceService.subtitle' | translate }}</p>
  </div>
  <div class="cards-container">
    <div class="card">
      @if (user.functions && user.functions.includes('CMB')) {
        <div class="content-container">
          <div class="header">
            <img src="/public/assets/images/hand-heart.svg" alt="hand with heart icon" />
            <h3>{{ 'assistanceService.assistance_card_title' | translate }}</h3>
          </div>
          <nz-divider></nz-divider>
          <p [innerHTML]="'assistanceService.assistance_card_subtitle' | translate"></p>
        </div>
        <div class="buttons-container">
          <ds-button class="button-service" [text]="'assistanceService.buttons.generic' | translate" [width]="'small'" (click)="genericButton()"></ds-button>
          <!-- <ds-button [text]="'assistanceService.buttons.covid' | translate" [width]="'small'" (click)="covidButton()"></ds-button> -->
        </div>
      }

      <div class="content-container">
        <div class="header">
          <img src="/public/assets/images/user-violet.svg" alt="user violet icon" />
          <h3>{{ 'assistanceService.contact_card_title' | translate }}</h3>
        </div>
        <nz-divider></nz-divider>
        <p [innerHTML]="'assistanceService.contact_card_subtitle' | translate"></p>

        <div class="telephone-container">
          <div class="phone">
            <p>{{ 'assistanceService.from_italy' | translate }}</p>
            <div>
              <img src="/public/assets/images/telephone-red.svg" alt="red telephone icon" />
              <span>{{ user.tollFreeNumber }}</span>
            </div>
          </div>
          <div class="phone">
            <p>{{ 'assistanceService.from_abroad' | translate }}</p>
            <div>
              <img src="/public/assets/images/telephone-red.svg" alt="red telephone icon" />
              <span>{{ user.phoneNumberBlack }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p class="alert-text" [innerHTML]="'assistanceService.service' | translate"></p>
</div>
